import { render } from "./VersionControls.vue?vue&type=template&id=10d1857a&scoped=true"
import script from "./VersionControls.vue?vue&type=script&lang=js"
export * from "./VersionControls.vue?vue&type=script&lang=js"

import "./VersionControls.vue?vue&type=style&index=0&id=10d1857a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d1857a"]])

export default __exports__